export default "__VITE_PUBLIC_ASSET__53ba669d__"